import { registerAction } from '../../Action'

const TOGGLE_ALL_FILTERS = 'TOGGLE_ALL_FILTERS'

const reducer = (state = {}) => ({
  ...state,
  filters: {
    ...state.filters,
    filtersDisabled: !state.filters.filtersDisabled,
  },
})

const toggleFilters = registerAction(TOGGLE_ALL_FILTERS, { reducer })

export default toggleFilters
